import { IgButton } from "@intelligems/ig-theme/IgButton";
import { useDispatch, useSelector } from "@src/store";
import {
  ExperienceBuilderAction,
  ExperienceBuilderSelector,
} from "@src/store/slices/experienceBuilder";
import { EmbeddedPreviewError } from "@src/features/experienceBuilder/pageState/EmbeddedPreviewError";

/**
 * Back re-points the preview rather than traversing history: the iframe is
 * cross-origin and, in this state, has no script of ours running in it, so
 * neither its history nor a postMessage is reachable — and `window.history`
 * belongs to the admin app, which a Back button here must never move. A
 * re-navigation is a fresh load (no bfcache, no scroll restore), accepted for
 * being deterministic.
 *
 * Its destination is `lastLocation`, which is preview-scoped and set for as long
 * as a builder is open, so the button is always offered.
 */
export const UnsupportedLocationError = () => {
  const dispatch = useDispatch();
  const lastLocation = useSelector(ExperienceBuilderSelector.getLastLocation);

  return (
    <EmbeddedPreviewError
      title={"Unsupported location"}
      description={
        "You have navigated to an unsupported location. Please navigate back."
      }
      buttons={
        <IgButton
          variant="contained"
          color="warning"
          onClick={() =>
            void dispatch(ExperienceBuilderAction.setTargetUrl(lastLocation))
          }
          sx={{ flex: 1 }}
        >
          Back
        </IgButton>
      }
    />
  );
};
